<mat-toolbar class="navbar mat-typography mat-elevation-z6" color="primary">
    <div class="min-md:hidden">
        <div class="navbar-collapse">
            <button routerLink="/"><img alt="SmartPart" class="nav-brand" ngSrc="./assets/app-logo.svg" height="117"
                                        width="659"></button>
            <button [matMenuTriggerFor]="menu" class="btn-collapse" mat-button>
                <mat-icon>menu</mat-icon>
            </button>
        </div>
    </div>
    <div class="nav-menu max-md:hidden">
        <a routerLink="/"><img alt="SmartPart" class="nav-brand inline-block" ngSrc="./assets/app-logo.svg" height="117" width="659"></a>
        <div class="nav-menu-list">
            <button mat-button routerLink="/items/search">Search</button>
            <button mat-button routerLink="/accounts">Accounts</button>
            <button mat-button routerLink="/users">Users</button>
            <button mat-button routerLink="/items/csv-upload">Import Inventory</button>
            <button [matMenuTriggerFor]="settings" mat-button>{{email}}</button>
            <mat-menu #settings="matMenu">
                <button (click)="logout()" mat-menu-item><i class="material-icons">power_settings_new</i> Log out
                </button>
            </mat-menu>
        </div>
    </div>
</mat-toolbar>
<mat-menu #menu="matMenu">
    <div>
        <button mat-button routerLink="/items/search">Search</button>
        <button mat-button routerLink="/accounts">Accounts</button>
        <button mat-button routerLink="/users">Users</button>
        <button mat-button routerLink="/items/csv-upload">Import Inventory</button>
        <button mat-button>{{email}}</button>
        <button (click)="logout()" mat-menu-item><i class="material-icons">power_settings_new</i> Log out</button>
    </div>
</mat-menu>
